<script setup>
import { ref, defineProps, defineEmits } from 'vue'

const props = defineProps(['fields'])

const emit = defineEmits(['selectField', 'showModal'])

const searchField = ref(null)

// 圃場リストグループ検索処理
function searchFieldList() {
  let field = props.fields.find(field => field.Name.includes(searchField.value));
  if (field) {
    document.getElementById(`list-${field.id}`).click();

    // 自動スクロール
    const element = document.getElementById(`list-${field.id}`);
    element.scrollIntoView({behavior: 'smooth'});
  }
}

// リスト選択イベント
function selectField(LatLng) {
  emit('selectField', LatLng);
}

// モーダル表示
function showModal(field) {
  emit('showModal', field);
}
</script>

<template>
  <button class="btn btn-sm btn-outline-primary w-100 mb-1 d-flex justify-content-center" type="button" @click="showModal()">
    <i class="bi bi-plus-square"></i> 新規登録
  </button>
  <form class="d-flex mb-1" role="search" @submit.prevent="searchFieldList()">
    <input class="form-control me-1" type="search" placeholder="Search" aria-label="Search" v-model="searchField">
    <button class="btn btn-sm btn-dark" type="submit"><i class="bi bi-search"></i></button>
  </form>
  <div class="list-group overflow-y-scroll" id="menu-field-list" role="tablist">
    <a class="list-group-item list-group-item-success list-group-item-action pe-1 pb-1" :id="`list-${ field.id }`" data-bs-toggle="list" role="tab" v-for="field in props.fields" :key="field" @click="selectField(field.LatLng)">
      <div class="d-flex w-100 justify-content-between">
        <h5 class="mb-1 text-decoration-underline">{{ field.Name }} </h5>
      </div>
      <p class="mb-0">作物：{{ field.Crop }}</p>
      <p class="mb-0">期間：{{ field.FromDT }}～{{ field.ToDT }}</p>
      <div class="d-flex w-100 justify-content-between">
        <p class="mb-0">担当：{{ field.Manager }}</p>
        <ul class="d-flex flex-row mb-0">
          <button class="btn btn-sm btn-success me-2" type="button" @click="showModal(field)"><i class="bi bi-pencil-square"></i> 編集</button>
          <button class="btn btn-sm btn-danger" type="button"><i class="bi bi-trash3"></i>削除</button>
        </ul>
      </div>
      <!-- <img class="w-100" :src="field.ImageUrl"> -->
    </a>
  </div>
</template>

<style scoped>
.list-group {
  height: 360px;
}
</style>
